const Timestamp = class {
  static generate() {
    return new Date().getTime();
  }
};

export default Timestamp;
